import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPjsipComponent } from './simple-icons-pjsip.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPjsipComponent ],
    exports:      [ SimpleIconsPjsipComponent ],
    bootstrap:    []
})
export class SimpleIconsPjsipModule {}
